import axios from 'axios';
import { v4 as uuid } from 'uuid';

import { getSiteKey } from '../components/RecaptchaProvider/RecaptchaProvider.utils';

const API = {
  loginClient: axios.create({
    baseURL: process.env.FISHERMAN_API_PATH,
    xsrfHeaderName: 'X-CSRFToken',
    xsrfCookieName: 'csrftoken',
    withCredentials: true,
  }),

  async searchBusiness(value, types = 'establishment') {
    const params = {
      input: value,
      session_token: uuid(),
      types,
    };

    try {
      const { data: results } = await API.loginClient.get(`businesses/search/autocomplete/`, {
        params,
      });

      return results;
    } catch (e) {
      return [];
    }
  },

  async searchPlaceDetails(placeId) {
    const params = { place_id: placeId };

    return API.loginClient.get(`businesses/search/place/details/`, { params });
  },

  async submitLead(formData, recaptchaToken) {
    const payload = {
      ...formData,
      'recaptcha-token': recaptchaToken,
      'recaptcha-site-key': getSiteKey(),
    };

    return API.loginClient.post(`/leads/form/`, payload);
  },
};

export default API;
